import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings";
import {SectionDescription} from "components/misc/Typography";
import { ReactComponent as LinkedinIcon} from "images/linkedin-icon.svg";
import { ReactComponent as GithubIcon } from "images/github-icon.svg";

const HeadingContainer = tw.div``
const Heading = tw(SectionHeading)``
const Subheading = tw(SubheadingBase)`text-center mb-3`
const Description = tw(SectionDescription)`mx-auto text-center`

const Cards = tw.div`flex flex-wrap flex-row justify-center sm:max-w-2xl lg:max-w-5xl mx-auto`
const Card = tw.div`mt-24 w-full sm:w-1/2 lg:w-1/3 flex flex-col items-center`

const CardContent = styled.div`
  ${tw`flex flex-col items-center mt-6`}
  .position {
    ${tw`uppercase font-bold tracking-widest text-xs text-primary-500`}
  }
  .name {
    ${tw`mt-1 text-xl font-medium text-gray-900`}
  9
`

const CardLinks = styled.div`
  ${tw`mt-6 flex`}
  .link {
    ${tw`mr-8 last:mr-0 text-gray-400 hocus:text-primary-500 transition duration-300`}
    .icon {
      ${tw`fill-current w-6 h-6`}
    }
  }
`

export default ({
  heading = "Who We Are",
  subheading = "Our Team",
  description = "",
  cards = [
    {
      imageSrc: "https://i.imgur.com/hvYoAR6.png",
      position: "Frontend/Backend",
      name: "Taylor Ngo",
      links: [
        {
          url: "https://www.linkedin.com/in/taylor-ngo/",
          icon: LinkedinIcon,
        },
        {
          url: "https://github.com/tayylorngo",
          icon: GithubIcon,
        },
      ],
      description: "Stony Brook University",
      description2: "Computer Science, B.S.",
      description3: "Applied Mathematics & Statistics, B.S.",
      description4: "Class of 2023"
    },
    {
      imageSrc: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
      position: "Backend",
      name: "Daoqin Gao",
      links: [
        {
          url: "https://www.linkedin.com/in/daoqin-gao/",
          icon: LinkedinIcon,
        },
        {
          url: "https://github.com/daoqingao",
          icon: GithubIcon,
        },
      ],
      description: "Stony Brook University",
      description2: "Computer Science, B.S.",
      description4: "Class of 2023"
    },
    {
      imageSrc: "",
      position: "Backend",
      name: "Michael Chan",
      links: [
        {
          url: "https://linkedin.com",
          icon: LinkedinIcon,
        },
        {
          url: "https://github.com/mchan10",
          icon: GithubIcon,
        },
      ],
      description: "Stony Brook University",
      description2: "Computer Science, B.S.",
      description3: "Applied Mathematics & Statistics, B.S.",
      description4: "Class of 2023"
    },
    {
      imageSrc: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&fit=facearea&facepad=2.95&w=512&h=512&q=80",
      position: "Frontend/Research",
      name: "Jeffrey Liew",
      links: [
        {
          url: "https://linkedin.com",
          icon: LinkedinIcon,
        },
        {
          url: "https://github.com",
          icon: GithubIcon,
        },
      ],
      description: "Stony Brook University",
      description2: "Information Systems, B.S.",
      description3: "Class of 2023"
    }
  ]
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading> }
          {description && <Description>{description}</Description> }
        </HeadingContainer>
        <Cards>
          {cards.map((card, index) => (
            <Card key={index}>
              {/*<CardImage imageSrc={card.imageSrc} />*/}
              <CardContent>
                <span className="position">{card.position}</span>
                <span className="name" style={{marginBottom: "10px"}}>{card.name}</span>
                <p className="description">
                  {card.description}
                </p>
                <p className="description">
                  {"" || card.description2}
                </p>
                <p className="description">
                  {"" || card.description3}
                </p>
                <p className="description">
                  {"" || card.description4}
                </p>
                <CardLinks>
                  {card.links.map((link, linkIndex) => (
                    <a key={linkIndex} className="link" href={link.url}>
                      <link.icon className="icon" />
                    </a>
                  ))}
                </CardLinks>
              </CardContent>
            </Card>
          ))}
        </Cards>
      </ContentWithPaddingXl>
    </Container>
  );
};
